/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

import pinia from '@/stores'
import { createHead } from '@unhead/vue/client'
import { JsonTreeView } from 'json-tree-view-vue3'
import deepUiLib from './deep-ui-lib.ts'
import initializeRouter from './router'
import './deep-libs.ts'
import AppLoader from '@/components/app/AppLoader.vue'
import deviceDetectorJs from './device-detector-js.ts'
import fontawesome from './fontawesome'
import i18n from './i18n'
import sentry from './sentry.ts'
import matomo from './vue-matomo.ts'
import vuetify from './vuetify.ts'
import 'json-tree-view-vue3/style.css'
import type { App } from 'vue'

export function registerPlugins(app: App) {
  app.use(vuetify)
  app.use(pinia)
  app.use(i18n)
  app.use(fontawesome)
  app.use(sentry)
  const head = createHead()
  app.use(head)
  app.use(deviceDetectorJs, { refreshOnResize: true })
  app.use(deepUiLib)

  // Global components
  app.component('AppLoader', AppLoader)
  app.component('JsonTreeView', JsonTreeView)

  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  const router = initializeRouter()
  app.use(matomo, router)

  // inject route to pinia in order to have access to the router instance inside pinia stores
  // https://stackoverflow.com/questions/70681667/cant-use-vue-router-and-pinia-inside-a-single-store
  pinia.use(({ store }) => {
    store.router = markRaw(router)
  })

  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  app.use(router)
}
